import { useCallback, useEffect, useState } from "react"
import { isChrome, isIOS, isMobileSafari } from "react-device-detect"

type Props = {
  disabled?: boolean
}

declare global {
  interface Document {
    mozFullScreenElement?: Element
    msFullscreenElement?: Element
    webkitFullscreenElement?: Element
  }
}

export function useFullScreenDetection(
  { disabled }: Props = { disabled: false }
) {
  const [fullScreenStatus, setFullScreenStatus] = useState(false)
  const prefixes = ["", "moz", "webkit", "ms"]

  const changeFullscreenStatus = useCallback(() => {
    setFullScreenStatus(
      document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
        ? true
        : false
    )
  }, [])

  /**
   * Prevent Full-Screen from keyboard keys
   */
  const listener = useCallback((e: KeyboardEvent) => {
    // console.log("event listener", e)
    if (e.key === "F11") {
      e.preventDefault()
    }
    if (e.key === "Escape") {
      e.preventDefault()
    }
  }, [])

  useEffect(() => {
    /**
     * if proctoring is disabled we return
     * if device is Mobile safari or ios chrome then we just return as it doesn't support fullscreen
     */
    if (disabled || isMobileSafari || (isChrome && isIOS)) {
      setFullScreenStatus(true)
      return
    }

    changeFullscreenStatus()

    prefixes.forEach(function (prefix) {
      document.addEventListener(
        prefix + "fullscreenchange",
        changeFullscreenStatus
      )
    })

    window.addEventListener("keydown", listener)

    return () => {
      prefixes.forEach(function (prefix) {
        document.removeEventListener(
          prefix + "fullscreenchange",
          changeFullscreenStatus
        )
      })
      window.removeEventListener("keydown", listener)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { fullScreenStatus } as const
}
